import ActionTypes from '@utils/deviceActions';
import { useMemo } from 'react';
import { DeviceActionProps } from '@components/Actions/ActionsModal/types';
import { IDevice } from '@pages/Assets/Inventory/types';
import { useTranslation } from 'react-i18next';
import rolesConstants from '@utils/rolesConstants';

interface SimcardResetPayloadProps {
  action: ActionTypes.SIMCARD_RESET;
  devices: {
    msisdn: string;
    iccid: string;
  }[];
}

interface SimcardResetProps {
  devices: IDevice[];
  isUpload?: boolean;
}

const useSimcardReset = ({
  devices,
  isUpload,
}: SimcardResetProps): DeviceActionProps => {
  const { t } = useTranslation('device-actions');

  const payloadToSend = useMemo(
    (): SimcardResetPayloadProps => ({
      action: ActionTypes.SIMCARD_RESET,
      devices: isUpload
        ? devices
        : devices?.map(device => ({
            msisdn: device.msisdn,
            iccid: device.iccid,
          })),
    }),
    [devices, isUpload],
  );

  return {
    steps: [],
    title: t(`labels.common.${rolesConstants.SIMCARD_RESET}`),
    payloadToSend,
  };
};

export default useSimcardReset;
